export default __webpack_public_path__ + "static/media/gallery-wip-paint_01.54793862.jpg";